module.exports = __webpack_public_path__ + "img/good-session-2.2b39ec6f.png";